// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.response-card-container[data-v-c460a2be] {
  width: 100%;
  max-width: 900px;
  margin-bottom: 8px;
  border-radius: 12px;
  overflow: hidden;
  background-color: #f5f5f5 !important;
  border: 1px solid #e0e0e0;
  transition: transform 0.2s ease;
  box-sizing: border-box;
  padding: 12px;
}
.response-card-container[data-v-c460a2be]:hover {
  transform: translateY(-2px);
}
.text-h5[data-v-c460a2be] {
  font-size: 16px !important;
  font-weight: 500;
  color: #333;
}
.v-card-subtitle[data-v-c460a2be] {
  color: #666;
}
.response-card-image[data-v-c460a2be] {
  border-radius: 8px;
  overflow: hidden;
  max-height: 180px;
  object-fit: cover;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}
.response-card-image[data-v-c460a2be]:hover {
  transform: scale(1.02);
}
.response-button-container[data-v-c460a2be] {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 8px 0;
  gap: 6px;
  width: 100%;
  box-sizing: border-box;
  margin-top: 8px;
  margin-left: 10px !important;
  background: transparent !important;
}
.v-card-actions[data-v-c460a2be] {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
}
.response-button[data-v-c460a2be] {
  background: #82b1ff !important;
  color: #000000 !important;
  border-radius: 20px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0.2px !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
  padding: 0 12px !important;
  height: 32px !important;
  margin: 4px !important;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
  position: relative;
  overflow: hidden;
  border: none !important;
  max-width: 100%;
  flex: 0 0 auto;
  box-sizing: border-box;
  font-size: 0.875rem !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.response-button[data-v-c460a2be]:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0));
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}
.response-button[data-v-c460a2be]:hover {
  background: #6889ff !important;
  color: #000000 !important;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2) !important;
  transform: translateY(-2px) !important;
}
.response-button[data-v-c460a2be]:hover:after {
  transform: translateX(100%);
}
.v-btn--disabled.response-button[data-v-c460a2be] {
  opacity: 0.26 !important;
  background-color: #E0EBFD !important;
  color: #000 !important;
}
.response-link-button[data-v-c460a2be] {
  background: rgba(130, 177, 255, 0.1) !important;
  color: #000000 !important;
  border: 1px solid #82b1ff !important;
  border-radius: 20px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0.2px !important;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05) !important;
  padding: 0 14px !important;
  height: 32px !important;
  font-size: 0.875rem !important;
}
.response-link-button[data-v-c460a2be]:hover {
  background: rgba(130, 177, 255, 0.2) !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
  transform: translateY(-2px) !important;
}
@media (max-width: 480px) {
.response-card-container[data-v-c460a2be] {
    max-width: 280px;
}
.response-button[data-v-c460a2be] {
    padding: 0 10px !important;
    height: 30px !important;
    font-size: 0.8rem !important;
}
.response-card-image[data-v-c460a2be] {
    max-height: 150px;
}
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
